import i18next from 'i18next'

const specs = {
    airQuality: ['environment', { ammonia: [0.2, 1, 2], methane: [1.5, 2.5, 1], pm25: [5, 25, 1], pm10: [10, 50, 1], temperature: [-5, 45, 1], humidity: [10, 90], aqi: [0, 300] }],
    coldStorage: ['coldStorage', { temperature: [-20, 6, 1], humidity: [35, 85], battery: [0, 100] }],
    soilMoisture: ['environment', { moisture1: [0, 100], moisture2: [0, 100], moisture3: [0, 100], moisture4: [0, 100], temperature1: [0, 40, 1], temperature2: [0, 40, 1], temperature3: [0, 40, 1], temperature4: [0, 40, 1], battery: [0, 100] }],
    weatherStation: ['environment', { temperature: [-10, 45, 1], humidity: [0, 100], rainfall: [0, 50, 1], windSpeed: [0, 60, 1], windDirection: [0, 359] }],
    waterTank: ['water', { level: [100, 3000], battery: [0, 100] }],
    waterTrough: ['water', { level: [10, 350], battery: [0, 100] }],
    waterDam: ['water', { level: [100, 5000] }],
    rainBucket: ['water', { rainfall: [0, 50, 1], rainfallDay: [0, 5, 1], rainfallWeek: [0, 40, 1], rainfallMonth: [0, 150, 1], rainfallRollingYear: [0, 1200, 1] }],
    waterPump: ['water', { flowRate: [0, 100, 1], runtime: [0, 24, 1], battery: [0, 100] }],
    energyConsumption: ['electrical', { kWhImport: [0, 10000, 1], kWhImportDay: [0, 100, 1], kWhImportWeek: [0, 700, 1], kWhImportMonth: [0, 3000, 1] }],
    distributionBoard: ['electrical', { l1Max: [230, 255], l1Min: [215, 230], l1THD: [0, 3, 1], l2Max: [230, 255], l2Min: [215, 230], l2THD: [0, 3, 1], l3Max: [230, 255], l3Min: [215, 230], l3THD: [0, 3, 1] }],
    distributionBoardSub: ['electrical', { i1Max: [0, 60], i2Max: [0, 60], i3Max: [0, 60], kWhImportDay: [0, 300, 1], kWhImportWeek: [0, 1500, 1], kWhImportMonth: [0, 6000, 1], kWhImportRollingYear: [0, 80000, 1] }],
    fencing: ['fencing', { voltage: [1500, 8000], battery: [0, 100] }],
    vehicle: ['vehicle', { speed: [0, 100], battery: [0, 100] }],
    vehicleCounting: ['object_counting', { '4WD': [0, 40], Ute: [0, 50], Truck: [0, 30], 'Large Vehicle': [0, 20], Car: [0, 100] }],
    livestockTracking: ['livestock', { battery: [0, 100], temperature: [30, 42, 1] }],
    livestockGroup: ['livestock', { count: [1, 500], averageWeight: [20, 700] }],
    paddock: ['paddock', { area: [1, 300, 1], ndvi: [0, 1, 2] }],
    chemical: ['chemical', { quantity: [1, 200, 1] }],
    equipment: ['equipment', { capacity: [50, 500] }],
    videoSurveillance: ['video', { count: [0, 100] }],
}
const coldStates = {
    condition: ['Good', 'Bad', 'Warning', 'Error', 'Critical'],
    power: ['Power On', 'Interruption', 'Overload', 'Over-voltage', 'Under-voltage', 'Short-circuit', 'Open-circuit', 'No-load', 'Power Off'],
    door: ['Open', 'Closed', 'Extended', 'Tamper'],
}
const airLabels = { ammonia: ['Ammonia', 'ppm'], methane: ['Methane', 'ppm'], pm25: ['PM2.5', 'µg/m³'], pm10: ['PM10', 'µg/m³'], temperature: ['Temperature', '°C'], humidity: ['Humidity', '%'], aqi: ['AQI', ''] }
const vehicleTypes = ['vehicleUte', 'vehicleTractor', 'vehicleCar', 'vehicleQuadbike', 'vehicleMotorbike', 'vehicleTruck', 'vehicleTrailer']

export class MockData {
    static get aqParams() {
        return [
            ['1013', [0.2, 1, 2], 'ppm', 'Gas Concentrations 2', '#009E7380', 'NH₃'],
            ['1026', [300, 600], 'µg/m³', 'Gas Concentrations 1', '#0072B280', 'CO₂'],
            ['1027', [100, 2000], 'µg/m³', 'Gas Concentrations 1', '#56B4E980', 'CO'],
            ['1028', [5, 100], 'µg/m³', 'Gas Concentrations 2', '#E69F0080', 'CH₂O'],
            ['1029', [10, 90], '%', 'Environmental Conditions', '#F0E44280'],
            ['1011', [1.5, 2.5, 1], 'ppm', 'Gas Concentrations 2', '#D55E0080', 'CH₄'],
            ['1030', [10, 100, 1], 'µg/m³', 'Gas Concentrations 1', '#CC79A780', 'NO₂'],
            ['1031', [30, 100], 'dB', null, '#1B9E7780'],
            ['1032', [0, 10, 1], 'µg/m³', 'Gas Concentrations 2', '#D95F0280', 'O₃'],
            ['PM1.0', [5, 20, 1], 'µg/m³', 'Particulate Matter', '#7570B380'],
            ['PM2.5', [5, 25, 1], 'µg/m³', 'Particulate Matter', '#E7298A80'],
            ['PM4', [5, 30, 1], 'µg/m³', 'Particulate Matter', '#66A61E80'],
            ['PM10', [10, 50, 1], 'µg/m³', 'Particulate Matter', '#E6AB0280'],
            ['1034', [0, 50, 1], 'mm', null, '#66666680'],
            ['2641', [5, 35], '%', 'Environmental Conditions', '#F0027F80'],
            ['1037', [0, 40], '°C', 'Environmental Conditions', '#BF5B1780', '1038'],
            ['1039', [1, 20, 1], 'µg/m³', 'Gas Concentrations 1', '#7F80B380', 'SO₂'],
            ['1040', [-5, 45], '°C', 'Environmental Conditions', '#B3DE8180'],
            ['1041', [980, 1050], 'hPa', 'Environmental Conditions', '#A6761D80'],
            ['1042', ['compass'], '', 'Wind Conditions', '#FDB46280'],
            ['1043', [0.1, 10, 1], 'km/h', 'Wind Conditions', '#CAB2D680'],
        ].map(([label, range, unit, group, color, formula]) => ({ label: /^\d+$/.test(label) ? i18next.t(label) : label, range, unit, group, color, ...(formula ? { formula: /^\d+$/.test(formula) ? i18next.t(formula) : formula } : {}) }))
    }

    static weighted(values, key) {
        const choices = coldStates[key]
        return choices[Math.round(values.reduce((sum, value) => sum + Math.max(choices.indexOf(value), 0), 0) / values.length)]
    }

    aqi() {
        const value = this.number(1, 20)
        const categories = [
            ['1006', 0, 6.7, '#42a93c'],
            ['1007', 6.7, 10, '#eec900'],
            ['1008', 10, 15, '#e47400'],
            ['1009', 15, 20, '#ba0029'],
            ['1010', 20, Infinity, '#590019'],
        ]
        const [label, min, max, color] = categories.find(([, min, max]) => value >= min && value <= max)
        return { label: i18next.t(label), range: [min, max], color, value }
    }

    airData({ start, end, groupBy = 'hour', measurements = ['PM1.0', 'PM2.5'], interval } = {}) {
        const params = MockData.aqParams.filter(param => measurements.includes(param.label))
        return this.points(start, end, interval || groupBy, () => Object.fromEntries(params.map(param => [param.label, typeof param.range[0] === 'number' ? this.number(...param.range) : this.pick(['N', 'S', 'E', 'W'])]))).map(([tsunix, content]) => ({
            sensorId: 'mock-air-quality',
            content,
            tsunix,
        }))
    }

    storageReading({ type = 'fridge', storageType = 'temperature' } = {}) {
        return storageType === 'humidity' ? this.number(type === 'freezer' ? 25 : 50, type === 'freezer' ? 65 : 85, 1) : this.number(...(type === 'freezer' ? [-20, -10, 1] : [0, 5, 1]))
    }

    storageForecast(count = 8, type = 'fridge', metric = 'temperature') {
        const baseline = this.storageReading({ type, storageType: metric })
        return Array.from({ length: Math.max(0, count) }, (_, index) => baseline + this.number(-1, 1, 1) + index * this.number(-0.05, 0.05, 2))
    }

    constructor({ seed, now = Date.now() } = {}) {
        this.state = seed === undefined ? null : Number(seed) >>> 0
        this.now = now
    }

    random() {
        if (this.state === null) return Math.random()
        this.state = (Math.imul(this.state, 1664525) + 1013904223) >>> 0
        return this.state / 4294967296
    }

    number(min, max, decimals = 0) {
        const scale = 10 ** decimals
        return Math.round((min + this.random() * (max - min)) * scale) / scale
    }

    pick(items) {
        return items[Math.floor(this.random() * items.length)]
    }

    values(type) {
        const spec = specs[type]
        if (!spec) throw new Error(`Unknown mock asset type: ${type}`)
        return Object.fromEntries(Object.entries(spec[1]).map(([key, range]) => [key, this.number(...range)]))
    }

    asset(type, { id = 1, farm, paddocks = [] } = {}) {
        const [group] = specs[type] || []
        if (!group) throw new Error(`Unknown mock asset type: ${type}`)
        const paddock = paddocks.length ? this.pick(paddocks) : null
        const rawLatitude = paddock?.latitude ?? farm?.latitude
        const rawLongitude = paddock?.longitude ?? farm?.longitude
        const latitude = Number(rawLatitude)
        const longitude = Number(rawLongitude)
        const location =
            rawLatitude !== null && rawLatitude !== undefined && rawLongitude !== null && rawLongitude !== undefined && Number.isFinite(latitude) && Number.isFinite(longitude) && latitude >= -90 && latitude <= 90 && longitude >= -180 && longitude <= 180
                ? { latitude: this.number(latitude - 0.005, latitude + 0.005, 6), longitude: this.number(longitude - 0.005, longitude + 0.005, 6) }
                : {}
        const content = this.values(type)
        const groupType = type === 'coldStorage' ? (id % 6 === 3 ? 'freezer' : 'fridge') : null
        if (groupType) content.temperature = this.number(...(groupType === 'fridge' ? [0, 5, 1] : [-20, -10, 1]))
        if (type === 'vehicle') Object.assign(content, location, { tilted: this.random() < 0.05, inTrip: this.random() < 0.8 })
        const chemicalDetail =
            type === 'chemical'
                ? {
                      type: this.pick(['Agricultural', 'Livestock', 'Veterinary', 'Pests Baits']),
                      batchNum: `B-${id}`,
                      numOfUnit: this.number(1, 20),
                      volPerUnit: this.number(1, 10),
                      unitOfMeasure: 'L',
                      expiryDate: new Date(this.now + this.number(-365, 730) * 86400000).toISOString().slice(0, 10),
                  }
                : {}
        const sensorId = `${type}-${id}`
        const payload = { sensorId, timestamp: new Date(this.now).toISOString(), content }
        return {
            id,
            farmId: farm?.id,
            name: `${type.replace(/([A-Z])/g, ' $1').replace(/^./, letter => letter.toUpperCase())} ${id}`,
            type: type === 'vehicle' ? vehicleTypes[(id - 1) % vehicleTypes.length] : type === 'chemical' ? 'chemicalProduct' : type === 'coldStorage' ? 'coolRoom' : type === 'equipment' ? 'machinery' : type,
            group,
            status: type === 'vehicleCounting' ? 'online' : groupType ? 'Active' : type === 'soilMoisture' && id % 2 === 0 ? 'Offline' : 'active',
            ...(groupType ? { groupType } : {}),
            detail: {
                isFake: true,
                ...location,
                ...content,
                ...chemicalDetail,
                ...(type === 'equipment' ? { sprayUnit: this.pick(['Boom Sprayer', 'Backpack Sprayer', 'Orchard Sprayer']), nozzleModel: 'Standard', nozzleSize: '02', boomHeight: '50 cm', systemPressure: '40 psi' } : {}),
                ...(groupType ? Object.fromEntries(Object.keys(coldStates).map(key => [key, this.pick(coldStates[key])])) : {}),
                fakeData: Object.entries(content).map(([key, value]) => ({ label: airLabels[key] && type === 'airQuality' ? airLabels[key][0] : key, value, unit: type === 'airQuality' ? airLabels[key]?.[1] || '' : '' })),
            },
            ...(paddock ? { paddockName: paddock.name } : {}),
            sensorIds: { [sensorId]: Object.keys(content) },
            sensors: { [sensorId]: { id: sensorId, type, name: `${type} sensor ${id}` } },
            payloads: { [sensorId]: payload },
            payloadsFirst: { [sensorId]: { ...payload, content: { ...content } } },
        }
    }

    assets(type, { count = 1, start = 1, ...options } = {}) {
        return Array.from({ length: count }, (_, index) => this.asset(type, { ...options, id: start + index }))
    }

    water({ farm, paddocks = [], rain = false } = {}) {
        if (rain) return this.assets('rainBucket', { count: 4, start: 10, farm, paddocks })
        return [
            ...this.assets('waterTank', { count: 3, farm, paddocks }),
            ...this.assets('waterDam', { count: 1, start: 4, farm, paddocks }),
            ...this.assets('waterTrough', { count: 1, start: 5, farm, paddocks }),
            ...this.assets('waterPump', { count: 1, start: 6, farm, paddocks }),
        ].map(asset => ({
            ...asset,
            detail: { ...asset.detail, maxLevel: asset.type === 'waterTrough' ? 350 : 3000, tankCapacity: 10000 },
        }))
    }

    fencing({ farm, paddocks = [] } = {}) {
        const names = paddocks.length ? paddocks.slice(0, 3).map(paddock => paddock.name) : ['North', 'East', 'South']
        return names.flatMap((name, index) => {
            const base = this.asset('fencing', { id: index + 1, farm, paddocks })
            return [
                {
                    ...base,
                    id: index * 3 + 1,
                    name: `${name} Boundary`,
                    type: 'fenceOutline',
                    group: 'infrastructure',
                    status: '',
                    payloads: {},
                    detail: { ...base.detail, geo: [{ type: 'polyline', coordinates: paddocks[index]?.path?.map(point => [point.latitude, point.longitude]) || [] }] },
                },
                { ...base, id: index * 3 + 2, name: `${name} Energiser`, type: 'fenceEnergiser', group: 'infrastructure', status: 'online', detail: { ...base.detail, energyOutput: this.number(100, 400), powerSource: 'Solar' } },
                { ...base, id: index * 3 + 3, name: `${name} Sensor`, type: 'electrifiedFence', group: 'infrastructure', status: 'online' },
            ]
        })
    }

    video({ farm, paddocks = [], feeds } = {}) {
        const feed = feeds?.[0] || { feed_id: 'mock-camera-feed', feed_status: 'Online', name: 'Demo camera' }
        return {
            feeds: feeds || [feed],
            videos: this.assets('videoSurveillance', { count: 4, farm, paddocks }).map(asset => ({
                ...asset,
                group: 'video_surveillance',
                detail: { ...asset.detail, feed_id: feed.feed_id, direction: this.pick(['N', 'S', 'E', 'W']), height: this.number(2, 5, 1) },
            })),
        }
    }

    electrical({ farm, count = 4 } = {}) {
        return Array.from({ length: count }, (_, index) => {
            const subId = 21 + index
            const board = this.asset('distributionBoard', { id: 9001 + index, farm })
            const sub = this.asset('distributionBoardSub', { id: subId, farm })
            return [
                { ...board, name: `Main Board ${index + 1}`, detail: { ...board.detail, groupAssetId: String(subId) } },
                { ...sub, name: `Sub Circuit ${index + 1}` },
            ]
        }).flat()
    }

    chemicals({ farm } = {}) {
        return [...Array.from({ length: 9 }, (_, index) => 111 + index), 210, 211].map(id => this.asset('chemical', { id, farm }))
    }

    paddocks({ farm, count = 12 } = {}) {
        if (!Number.isFinite(Number(farm?.latitude)) || !Number.isFinite(Number(farm?.longitude)) || farm?.latitude == null || farm?.longitude == null) return []
        return Array.from({ length: count }, (_, index) => {
            const latitude = Number(farm.latitude) + (Math.floor(index / 4) - 1) * 0.004
            const longitude = Number(farm.longitude) + ((index % 4) - 1.5) * 0.006
            const path = [
                [0, 0],
                [0.003, 0],
                [0.003, 0.004],
                [0, 0.004],
                [0, 0],
            ].map(([lat, lon]) => ({ latitude: latitude + lat, longitude: longitude + lon }))
            const state = this.pick(['Grazing', 'Resting', 'Fallow'])
            return {
                id: index + 1,
                farmId: farm.id,
                name: `Paddock ${index + 1}`,
                group: 'paddock',
                type: 'field',
                shape: 'polygon',
                path,
                latitude,
                longitude,
                area: this.number(4, 45, 1),
                isFake: true,
                detail: { isFake: true, pastureState: state, pastureType: this.pick(['Clover', 'Ryegrass', 'Lucerne']), foo: this.number(500, 3000), stockingRate: this.number(5, 20), colour: '#4caf50' },
            }
        })
    }

    groups({ farm, paddocks = [] } = {}) {
        return ['Cattle', 'Sheep'].map((species, index) => {
            const id = 8000 + index
            const animals = Array.from({ length: 10 }, (_, animalIndex) => ({
                id: id * 10 + animalIndex,
                farmId: farm?.id,
                size: 1,
                paddockId: paddocks.length ? paddocks[animalIndex % paddocks.length].id : null,
                detail: {
                    species,
                    breed: species === 'Cattle' ? 'Angus' : 'Merino',
                    isFake: true,
                    birth: { dateOfBirth: '2024-09-17', birthWeight: species === 'Cattle' ? 40 : 4, gender: 'Female' },
                    production: { lifetimeADG: species === 'Cattle' ? 0.75 : 0.15, targetLiveWeight: species === 'Cattle' ? 550 : 70 },
                    health: { status: 'Active' },
                },
            }))
            return { id, farmId: farm?.id, name: `${species} Group`, size: animals.length, animalIds: animals.map(animal => animal.id), animals, detail: { species, isFake: true } }
        })
    }

    mobs({ farm, paddocks = [], count = 6 } = {}) {
        return Array.from({ length: count }, (_, index) => {
            const species = index % 2 ? 'Sheep' : 'Cattle'
            const paddock = paddocks.length ? paddocks[index % paddocks.length] : null
            const animalCount = this.number(10, 80)
            return {
                id: index + 1,
                farmId: farm?.id,
                name: `${species} Mob ${index + 1}`,
                type: species,
                animalType: species,
                breed: species === 'Cattle' ? 'Angus' : 'Merino',
                gender: 'Mixed',
                group: 'livestock',
                animalCount,
                paddockId: paddock?.id,
                paddockName: paddock?.name,
                paddockPath: paddock?.path,
                detail: { isFake: true },
                summary: { [species]: { total: animalCount } },
            }
        })
    }

    grazing({ farm } = {}) {
        const date = offset => new Date(this.now + offset * 86400000).toISOString().slice(0, 10)
        return [
            { id: 90001, farmId: farm?.id, name: 'Perpetual Plan', group: 'grazingPlan', type: 'cluster', series: [91001], startTime: date(-21), detail: { subtype: 1, planType: 1, isFake: true } },
            { id: 91001, farmId: farm?.id, name: 'Spring Grazing', group: 'grazingPlan', type: 'group', parentId: 90001, series: [92001, 92002], detail: { subtype: 2, foo: this.number(1500, 5000), paddock: { id: 1, area: 20 }, isFake: true } },
            { id: 92001, farmId: farm?.id, name: 'Grazing', group: 'grazingPlan', type: 'event', parentId: 91001, startTime: date(-7), endTime: date(7), detail: { subtype: 3, isFake: true } },
            { id: 92002, farmId: farm?.id, name: 'Resting', group: 'grazingPlan', type: 'event', parentId: 91001, startTime: date(8), endTime: date(21), detail: { subtype: 3, isFake: true } },
        ]
    }

    tracking({ farm, paddocks = [], mobs = [] } = {}) {
        const tags = Array.from({ length: 6 }, (_, index) => {
            const location = this.asset('livestockTracking', { id: index + 1, farm, paddocks }).detail
            return { id: `mock-tag-${index + 1}`, batCap: this.number(20, 100), charge: this.random() > 0.5, lat: location.latitude, lon: location.longitude, ts: this.now - this.number(0, 48) * 3600000 }
        })
        const animals = tags.map((tag, index) => ({
            id: index + 1,
            farmId: farm?.id,
            type: index % 2 ? 'Sheep' : 'Cattle',
            breed: index % 2 ? 'Merino' : 'Angus',
            gender: this.pick(['Female', 'Male']),
            mobId: mobs[index % mobs.length]?.id,
            paddockId: index % 3 === 0 ? null : paddocks[index % paddocks.length]?.id,
            sensorIds: [tag.id],
            sensors: { [tag.id]: { id: tag.id, name: `LSTAG_${index + 1}` } },
            timestamp: tag.ts,
            detail: { isFake: true },
        }))
        const gateways = Array.from({ length: 3 }, (_, index) => ({ gatewayID: `mock-gateway-${index + 1}`, frequency: '917500000', latitude: farm?.latitude, longitude: farm?.longitude }))
        const sensors = tags.map((tag, index) => ({
            id: tag.id,
            name: `LSTAG_${index + 1}`,
            type: 82,
            sensorType: 'cow_tracking',
            userMetadata: { association: { type: 'animal', id: animals[index].id, mobId: animals[index].mobId } },
            stats: { latitude: String(tag.lat), longitude: String(tag.lon), gatewayID: gateways[index % gateways.length].gatewayID },
        }))
        return { tags, animals, gateways, sensors }
    }

    soilChart(start, end) {
        const from = new Date(start).getTime()
        const to = new Date(end).getTime()
        if (!Number.isFinite(from) || !Number.isFinite(to) || to < from) return null
        const interval = Math.max(3600000, Math.ceil((to - from) / 720 / 3600000) * 3600000)
        const make = (type, keys) => {
            const data = keys.map(key => ({ name: key.replace(/(\d+)$/, ' $1'), data: this.series(type, key, { start: from, end: to, interval }).map(point => [new Date(point.timestamp).getTime(), point.value]) }))
            const values = data.flatMap(item => item.data.map(point => point[1]))
            return { data, min: Math.min(...values) * 0.95, max: Math.max(...values) * 1.05 }
        }
        return {
            moisture: make(
                'soilMoisture',
                [1, 2, 3, 4].map(i => `moisture${i}`),
            ),
            temperature: make(
                'soilMoisture',
                [1, 2, 3, 4].map(i => `temperature${i}`),
            ),
            battery: { data: ['Battery Voltage', 'Solar Voltage'].map(name => ({ name, data: this.series('soilMoisture', 'battery', { start: from, end: to, interval }).map(point => [new Date(point.timestamp).getTime(), point.value / 20]) })) },
        }
    }

    points(start, end, interval = 'hour', value = () => this.number(0, 100)) {
        const steps = { minute: 60000, quarterHour: 900000, hour: 3600000, day: 86400000, month: 2592000000, year: 31536000000, '30 minutes': 1800000 }
        const from = new Date(start).getTime()
        const to = new Date(end).getTime()
        const step = typeof interval === 'number' ? interval : steps[interval] || steps.hour
        if (!Number.isFinite(from) || !Number.isFinite(to) || !Number.isFinite(step) || step <= 0 || to < from) return []
        const count = Math.min(10000, Math.floor((to - from) / step) + 1)
        return Array.from({ length: count }, (_, index) => [from + index * step, value(index)])
    }

    waterDaily(asset, query, incremental = false) {
        const content = Object.values(asset?.payloads || {})[0]?.content || {}
        const max = Number(asset?.detail?.maxLevel) || 2500
        const base = Number(incremental ? content.rainfall || content.usage || 2 : content.level || max / 2)
        return this.points(query?.start, query?.end, query?.interval || 'quarterHour', () => this.number(Math.max(0, base * 0.9), Math.min(incremental ? Infinity : max, base * 1.1), incremental ? 2 : 0))
    }

    waterYearly(asset) {
        const now = new Date(this.now)
        const base = Number(Object.values(asset?.payloads || {})[0]?.content?.level) || 100
        return Array.from({ length: 48 }, (_, index) => {
            const date = new Date(now.getFullYear() - 3 + Math.floor(index / 12), index % 12, 1)
            return date.getTime() <= this.now ? { tsunix: date.getTime(), sensorId: 'mock', content: { level: this.number(Math.max(0, base * 0.5), base * 1.5) } } : null
        }).filter(Boolean)
    }

    fenceSeries(query, baseVoltage = 3000) {
        return this.points(query?.start, query?.end, query?.interval, () => this.number(baseVoltage * 0.8, baseVoltage * 1.2))
    }

    electricalSeries(sensorIds, start, end, interval, metric) {
        return Object.fromEntries(sensorIds.map(id => [id, this.points(start, end, interval, () => this.number(0, metric?.toLowerCase().includes('voltage') ? 260 : 1000, 1)).map(([tsunix, value]) => ({ tsunix, value }))]))
    }

    pumpDaily(formatData) {
        const events = Array.from({ length: 78 }, (_, index) => {
            const start = this.now - (78 - index) * 2 * 86400000 + this.number(6, 16) * 3600000
            return [
                { tsunix: start, content: { status: true, count: index * 2 + 1 } },
                { tsunix: start + this.number(4, 8) * 3600000, content: { status: false, count: index * 2 + 2 } },
            ]
        }).flat()
        return [{ name: 'Level', data: (formatData(events)?.daily || []).map(item => ({ ...item, rangeName: `pump-${this.number(1, 100000)}` })) }]
    }

    pumpRuntime(series) {
        return (series?.[0]?.data || []).filter(item => item.status === 'On').map(item => [item.y[0], Math.max(0, Math.round((item.y[1] - item.y[0]) / 60000))])
    }

    pumpCounts(series) {
        const counts = {}
        ;(series?.[0]?.data || [])
            .filter(item => item.status === 'On')
            .forEach(item => {
                const date = new Date(item.y[0]).toISOString().slice(0, 10)
                counts[date] = (counts[date] || 0) + 1
            })
        return Object.entries(counts).map(([date, count]) => ({ date, count }))
    }

    pumpEvents(pumpId) {
        return Array.from({ length: 8 }, (_, index) => ({
            timestamp: this.now - index * this.number(7, 30) * 86400000,
            who: this.pick(['John Smith', 'Sarah Johnson', 'Emma Wilson']),
            new: { asset: pumpId, type: this.pick(['Maintenance', 'Inspection', 'Repair']), group: 'Service', desc: 'Pump service completed' },
        }))
    }

    vehicleCounts(start, end, interval = 1) {
        const step = Math.max(1, Number(interval) || 1) * 3600000
        return this.points(start, end, step, () => Object.fromEntries(['4WD', 'Ute', 'Truck', 'Large Vehicle', 'Car'].map(type => [type, this.number(0, 20)]))).map(([timestamp, items]) => ({
            timestamp: new Date(timestamp),
            items,
            count: Object.values(items).reduce((sum, value) => sum + value, 0),
        }))
    }

    vehicleCounting({ count = 4, farm, latlng, key } = {}) {
        const locationFarm = farm || { latitude: latlng?.latitude, longitude: latlng?.longitude }
        const assets = Array.from({ length: count }, (_, index) => {
            const asset = this.asset('vehicleCounting', { id: 91000 + index, farm: locationFarm })
            const sensorId = Object.keys(asset.payloads)[0]
            const hour = this.vehicleCounts(this.now - 3600000, this.now)[0]
            const content = { vehicle: { hour, day: { ...hour, count: hour.count * 24 }, week: { ...hour, count: hour.count * 168 } } }
            const { latitude, longitude } = asset.detail
            return {
                ...asset,
                path:
                    Number.isFinite(latitude) && Number.isFinite(longitude)
                        ? [
                              [latitude, longitude],
                              [latitude + 0.001, longitude + 0.001],
                          ]
                        : [],
                detail: { ...asset.detail, feed: `Camera ${index + 1}`, subtype: 'Vehicle' },
                payloads: { [sensorId]: { ...asset.payloads[sensorId], content } },
                payloadsFirst: { [sensorId]: { ...asset.payloads[sensorId], content } },
            }
        })
        if (key && typeof sessionStorage !== 'undefined') sessionStorage.setItem(key, JSON.stringify(assets))
        return assets
    }

    vehiclePath(vehicle, start, end, count = 40) {
        const latitude = Number(vehicle?.detail?.latitude)
        const longitude = Number(vehicle?.detail?.longitude)
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude) || vehicle?.detail?.latitude == null || vehicle?.detail?.longitude == null) return []
        const from = new Date(start).getTime()
        const to = new Date(end).getTime()
        if (!Number.isFinite(from) || !Number.isFinite(to) || to < from) return []
        return Array.from({ length: Math.max(2, count) }, (_, index) => {
            const angle = (index / count) * Math.PI * 2
            return {
                tsunix: from + ((to - from) * index) / (count - 1),
                content: {
                    latitude: latitude + Math.sin(angle) * 0.003,
                    longitude: longitude + Math.cos(angle) * 0.003,
                    altitude: this.number(0, 100),
                    temperature: this.number(20, 40, 1),
                    battery: this.number(80, 100),
                    tilted: this.random() > 0.95 ? 1 : 0,
                    inTrip: this.random() > 0.2 ? 1 : 0,
                },
            }
        })
    }

    tagPath({ start, end, farm } = {}) {
        const latitude = Number(farm?.latitude)
        const longitude = Number(farm?.longitude)
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) return []
        const from = new Date(start).getTime()
        const to = new Date(end).getTime()
        if (!Number.isFinite(from) || !Number.isFinite(to) || to < from) return []
        const count = Math.min(24, Math.max(1, Math.ceil((to - from) / 1800000)))
        return Array.from({ length: 5 }, (_, tag) =>
            Array.from({ length: count }, (_, index) => {
                const ts = from + ((to - from) * index) / count
                return [`mock-tag-${tag + 1}`, ts, latitude + Math.sin(index / 3 + tag) * 0.005, longitude + Math.cos(index / 3 + tag) * 0.005, new Date(ts).getHours()]
            }),
        ).flat()
    }

    tagMetrics({ start, end, metric = 'usage', range = '30 minutes', mobs = [], paddocks = [] } = {}) {
        const interval = Math.max(1, parseInt(range, 10) || 30) * 60000
        return mobs.slice(0, 6).flatMap((mob, index) => {
            const paddock = paddocks.find(item => item.id === mob.paddockId)
            const location = paddock?.path?.[0]
            if (!location) return []
            return this.points(start, end, interval, () => [this.number(Number(location.latitude) - 0.0005, Number(location.latitude) + 0.0005, 6), this.number(Number(location.longitude) - 0.0005, Number(location.longitude) + 0.0005, 6)]).map(
                ([timestamp, [lat, lon]]) =>
                    metric === 'usage'
                        ? [`mock-tag-${index + 1}`, timestamp, lat, lon, new Date(timestamp).getHours()]
                        : [
                              index,
                              `mock-tag-${index + 1}`,
                              timestamp,
                              1,
                              lat,
                              lon,
                              [this.number(0, 6, 1), false, false],
                              this.number(-140, -40),
                              this.number(-15, 15),
                              this.number(3500, 4300),
                              false,
                              this.number(25, 100),
                              this.number(0, 1000),
                              this.number(0, 5, 1),
                              this.number(0, 360),
                          ],
            )
        })
    }

    resourceUtilisation(tagMetrics, waterResources, start, end) {
        if (!tagMetrics?.length || !waterResources?.length) return []
        const ids = [...new Set(tagMetrics.map(row => row[0]))]
        return waterResources.map(resource => {
            const tags = Object.fromEntries(ids.filter(() => this.random() > 0.5).map(id => [id, this.number(300, 5400)]))
            const totalDuration = Object.values(tags).reduce((sum, value) => sum + value, 0)
            const numberOfVisits = Object.keys(tags).length
            return { id: resource.id, name: resource.name, type: resource.type, numberOfVisits, avgDuration: numberOfVisits ? totalDuration / numberOfVisits : 0, totalDuration, start, end, tags }
        })
    }

    mobsSummary({ farm, paddocks = [] } = {}) {
        const summary = Object.fromEntries(['Sheep', 'Cattle'].map(species => [species, { total: 0, genders: {}, births: { older: 0 } }]))
        this.mobs({ farm, paddocks }).forEach(mob => {
            summary[mob.type].total += mob.animalCount
            summary[mob.type].genders.Mixed = (summary[mob.type].genders.Mixed || 0) + mob.animalCount
            summary[mob.type].births.older += mob.animalCount
        })
        return { [farm?.id || 1]: summary }
    }

    weatherStation({ lat, lng } = {}) {
        const asset = this.asset('weatherStation', { farm: { latitude: lat, longitude: lng } })
        const id = Object.keys(asset.payloads)[0]
        const content = {
            ...asset.payloads[id].content,
            temperature: this.number(12, 30, 1),
            humidity: this.number(30, 80),
            windSpeed: this.number(0, 8, 1),
            battery: this.number(30, 90),
            pressure: this.number(99000, 104000),
            rainfallDay: this.number(0, 5, 1),
            rainfallWeek: this.number(0, 40, 1),
            rainfallMonth: this.number(0, 150, 1),
            rainfallRollingYear: this.number(0, 1200, 1),
            signal: this.pick(['h', 'm', 'l']),
        }
        return { ...asset, sensorIds: { [id]: Object.keys(content) }, payloads: { [id]: { ...asset.payloads[id], content } }, payloadsFirst: { [id]: { ...asset.payloads[id], content } } }
    }

    weatherHistory(start, end, groupBy = 'day', rainfallOnly = false) {
        const step = groupBy === 'hour' ? 3600000 : 86400000
        return this.points(start, end, step, () => this.values('weatherStation')).map(([tsunix, values]) => ({
            sensorId: 'mock-weather',
            tsunix,
            content: rainfallOnly
                ? { rainfall: values.rainfall, rainfallDay: values.rainfall, rainfallWeek: values.rainfall * 7, rainfallMonth: values.rainfall * 30, rainfallRollingYear: values.rainfall * 365 }
                : { ...values, temperature: this.number(12, 30, 1), humidity: this.number(30, 80), windSpeed: this.number(0, 8, 1), battery: this.number(30, 90), pressure: this.number(99000, 104000) },
        }))
    }

    livestockCounts(days = 2) {
        const end = new Date(this.now).setHours(0, 0, 0, 0) + 86400000
        return Array.from({ length: days * 2 }, (_, index) => ({ ts: end - (days - Math.floor(index / 2)) * 86400000, count: this.number(100, 300), countingDirection: index % 2 ? 'down' : 'up' }))
    }

    bleCounts(payload, location = {}) {
        return {
            items: (payload?.items || []).map(item => {
                const start = Number(item.start) || this.now - 86400000
                const end = Math.min(Number(item.end) || this.now, this.now)
                const unit = item.range?.split(' ')[1]?.toLowerCase()
                const step = Math.max(60000, (parseInt(item.range, 10) || 60) * (unit?.startsWith('d') ? 86400000 : unit?.startsWith('h') ? 3600000 : 60000))
                const dt = item.range ? this.points(start, end, step).map(([ts]) => ts - start) : [0]
                return [
                    {
                        group: {},
                        timestampStart: start,
                        dt,
                        values:
                            item.indexName === 'tag_gateway' && !item.fields?.some(field => field.alias === 'count')
                                ? { altitude: [this.number(0, 100)], battery: [this.number(3, 4, 1)], lat: [location.lat], lon: [location.lon], 'min(timestamp)': [start], temperature: [this.number(20, 30)], tsFirst: [start], tsLast: [end] }
                                : { count: dt.map(() => this.number(item.indexName === 'tag_presence' ? 1 : 280, item.indexName === 'tag_presence' ? 5 : 320)) },
                    },
                ]
            }),
        }
    }

    bleTags(count) {
        return Array.from({ length: Math.max(0, count) }, (_, index) => ({
            id: `mock-tag-${index + 1}`,
            associatedType: 0,
            associatedId: '',
            reason: ['found'],
            location: '',
            timestamp: { first: this.now - 86400000, last: this.now, now: this.now },
            txpower: { first: -56, last: -56 },
            rssi: this.number(-120, -40),
        }))
    }

    agriRecords({ paddocks = [] } = {}) {
        return paddocks.flatMap(paddock =>
            Array.from({ length: 3 }, (_, index) => {
                const date = new Date(this.now - this.number(1, 365) * 86400000).toISOString().slice(0, 10)
                return {
                    id: `record-${paddock.id}-${index}`,
                    operator: `Operator ${index + 1}`,
                    timestamp: date,
                    startTime: '09:00',
                    finishTime: '12:00',
                    paddocks: paddock.name,
                    product: 'Herbicide',
                    productAmount: this.number(1, 6, 2),
                    area: this.number(5, 25, 2),
                    crop: 'Pasture',
                    windSpeed: String(this.number(5, 15, 1)),
                    windDirection: this.pick(['N', 'S', 'E', 'W']),
                    temperature: String(this.number(15, 30)),
                    humidity: this.number(40, 80),
                    isOldSprayingType: false,
                }
            }),
        )
    }

    paddockAgriRecords(paddock) {
        return this.agriRecords({ paddocks: [paddock] }).map(row => [
            row.id,
            row.timestamp,
            row.startTime,
            row.finishTime,
            row.paddocks,
            row.product,
            'Boom Sprayer',
            `${row.productAmount} L`,
            String(row.area),
            `${this.number(1, 7)} days`,
            row.crop,
            row.windSpeed,
            row.windDirection,
            Number(row.temperature),
            `${row.humidity}%`,
            row.operator,
            'Supervisor',
            'Client',
            '',
        ])
    }

    vetRecords({ product, mobs = [] } = {}) {
        if (!product || !mobs.length) return []
        return Array.from({ length: 6 }, (_, index) => {
            const mob = mobs[index % mobs.length]
            return [
                String(index + 1),
                new Date(this.now - index * 86400000).toLocaleDateString('en-GB'),
                'Treatment',
                'completed',
                `${product.detail?.whp || 0} days`,
                product.detail?.batchNum || '',
                product.detail?.expiryDate || '',
                mob.name,
                mob.animalType || 'Sheep',
                `Vet ${index + 1}`,
                'All',
                `${this.number(10, 50, 2)} ${product.detail?.unitOfMeasure || 'mL'}`,
                '',
                'All (10)',
                '',
                '',
            ]
        })
    }

    taskProjects({ farm, tenant } = {}) {
        if (!farm || !tenant) return []
        return ['Fence Repair', 'Livestock Check', 'Water Maintenance'].map((name, index) => ({
            id: 10001 + index,
            name,
            description: name,
            category: 'infrastructure',
            farmId: farm.id,
            tenantId: tenant,
            createdAt: new Date(this.now - 30 * 86400000).toISOString(),
            updatedAt: new Date(this.now).toISOString(),
            users: [{ id: 1, name: 'Farm Manager', email: 'manager@example.com', tenantId: tenant }],
            issues: Array.from({ length: 3 }, (_, issueIndex) => ({
                id: 400 + index * 10 + issueIndex,
                title: `${name} ${issueIndex + 1}`,
                type: 'task',
                status: issueIndex === 2 ? 'completed' : issueIndex === 1 ? 'inprogress' : 'open',
                priority: '3',
                listPosition: issueIndex + 1,
                descriptionText: name,
                attachments: null,
                reporterId: 1,
                estimate: null,
                timeSpent: null,
                timeRemaining: null,
                createdAt: new Date(this.now - 7 * 86400000).toISOString(),
                updatedAt: new Date(this.now).toISOString(),
                userIds: [1],
                dueDate: new Date(this.now + 7 * 86400000).toISOString(),
                branchId: 1,
                groupId: null,
                lat: null,
                lng: null,
                projectId: 10001 + index,
                tenantId: tenant,
            })),
        }))
    }

    animalEvents(tenant, animal, group = false) {
        if (!tenant || animal?.id == null) return []
        const id = animal.id
        const key = `am-demo-${group ? 'group' : 'animal'}-events:${tenant}:${id}`
        try {
            const cached = JSON.parse(sessionStorage.getItem(key))
            if (Array.isArray(cached)) return cached
        } catch {
            /* invalid or unavailable storage */
        }
        const source = group ? animal.animals?.[0] : animal
        const aIds = group ? (animal.aIds?.length ? animal.aIds : animal.animalIds || []).slice(0, 3) : [id]
        const paddockIds = source?.paddockId == null ? [] : [source.paddockId]
        const farmIds = [source?.farmId || 1]
        const dob = new Date(source?.detail?.birth?.dateOfBirth || this.now - 400 * 86400000).getTime()
        const birthWeight = Number(source?.detail?.birth?.birthWeight) || 40
        const adg = Number(source?.detail?.production?.lifetimeADG) || 0.75
        const weighings = [14, 45, 90, 150, 220, 300, 380]
            .filter(days => dob + days * 86400000 < this.now)
            .map((days, index) => {
                const weightKg = Math.round((birthWeight + days * adg) * 10) / 10
                return {
                    id: `demo-ev-${id}-weigh-${index}`,
                    time: new Date(dob + days * 86400000).toISOString(),
                    aIds,
                    paddockIds,
                    farmIds,
                    userIds: [1],
                    type: 'animalsWeighing',
                    detail: { kind: 'weighing.session', data: { weightKg }, weigh: { weightKg, weightUnit: 'kg', animalRefSource: 'cohort' } },
                }
            })
        const types = group
            ? ['animalsMovement', 'animalsTreatment', 'health', 'breeding', 'birthing', 'grouping', 'animalsAdjustment', 'membershipChanged', 'animalsEdited', 'note', 'upload', 'legacyVetChemicalEvent']
            : ['health', 'animalsTreatment', 'animalsTreatment', 'animalsEdited', 'health']
        const details = {
            animalsMovement: { kind: 'movement.moveGroup', data: { locationChange: { from: paddockIds.map(paddockId => ({ paddockId })), to: { paddockId: paddockIds[0] } }, reason: 'rotation' } },
            animalsTreatment: { kind: 'treatment.productTreatment', data: { treatmentName: 'Vaccination', productUsed: 1, subtype: 'vaccination' } },
            health: { kind: 'health.check', data: { outcome: 'Healthy', notes: 'Routine check' } },
            breeding: { kind: 'reproduction.service', data: { method: 'AI', sire: 'Bull' } },
            birthing: { kind: 'reproduction.birth', data: { outcome: 'Live', assistance: 'None' } },
            grouping: { kind: 'grouping.splitGroup', data: { note: 'Split' } },
            animalsAdjustment: { kind: 'adjustment.addAnimals', data: { newAnimals: 1 } },
            membershipChanged: { kind: 'membershipChanged.add', data: { operation: 'add', newAnimals: 1 } },
            animalsEdited: { animals: { bodyConditionScore: 3 } },
            note: { data: { text: 'Yard note' } },
            upload: { data: { fileName: 'import.csv' } },
            legacyVetChemicalEvent: { data: { product: 'Treatment' } },
        }
        const events = [...weighings, ...types.map((type, index) => ({ id: `demo-ev-${id}-${type}-${index}`, time: new Date(this.now - (index + 1) * 86400000).toISOString(), aIds, paddockIds, farmIds, userIds: [1], type, detail: details[type] }))].sort(
            (a, b) => new Date(b.time) - new Date(a.time),
        )
        try {
            sessionStorage.setItem(key, JSON.stringify(events))
        } catch {
            /* unavailable storage */
        }
        return events
    }

    stored(key) {
        try {
            return JSON.parse(sessionStorage.getItem(key)) || []
        } catch {
            return []
        }
    }

    alerts({ count = 8 } = {}) {
        return Array.from({ length: count }, (_, index) => ({
            id: index + 1,
            name: 'Low level',
            enabled: this.random() > 0.2,
            entityType: index % 4 === 3 ? 4 : 1,
            entityId: index + 1,
            entityName: `Sensor ${index + 1}`,
            sensorIds: [`mock-${index + 1}`],
            rules: { rules: [{ path: 'level', value: this.number(20, 80), comparator: 'lte' }], condition: 'RULESET_CONDITION_ALL' },
            isFake: true,
        }))
    }

    series(type, metric, { start = this.now - 86400000, end = this.now, interval = 3600000 } = {}) {
        const range = specs[type]?.[1]?.[metric]
        if (!range) throw new Error(`Unknown mock metric: ${type}.${metric}`)
        const from = new Date(start).getTime()
        const to = new Date(end).getTime()
        if (!Number.isFinite(from) || !Number.isFinite(to) || !Number.isFinite(interval) || interval <= 0 || to < from) throw new Error('Invalid mock series range')
        const count = Math.floor((to - from) / interval) + 1
        if (count > 10000) throw new Error('Mock series exceeds 10000 points')
        return Array.from({ length: count }, (_, index) => ({ timestamp: new Date(from + index * interval).toISOString(), value: this.number(...range) }))
    }
}
